import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import clsx from 'clsx';
import BlockButton from 'components/UI/BlockButton';
import config from 'config/api';
import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';
import RegistrationForm from 'components/Registration/RegistrationTwoStepsForm';
import DialogPopinButton from 'components/UI/Dialog/DialogPopinButton';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { menuColor } from 'helpers/colors';
import { fetchData } from '../../ducks/asyncFetcher';
import i18n from 'helpers/i18n';
import IconArrow from '@material-ui/icons/ArrowDropDown';
import Popper from '@material-ui/core/Popper';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import PersonIcon from '@material-ui/icons/Person';

import { isLoggedIn, getCurrentUserRole, getCurrentUserSubRole, getCurrentUser } from 'ducks/authentication';

const AF_KEY = 'home';

const styles = (theme) => {
  return {
    root: {
    },
    logoWrapper: {
      display: 'block',
      textAlign: 'right',
      width: '100%'
    },
    logo: {
      width: 80,
    }
  };
};
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }
  handleToggle = (e, url) => {
    this.setState((state) => ({ open: !state.open }));
  };
  handleClose = (e, url) => {
    this.setState((state) => ({ open: false }));
    this.props.history.push(url)
  };
  render() {
    const { classes, isLoggedIn, $$user } = this.props;
    const userRole = $$user !== undefined ? $$user.get('role') : undefined;
    const $$profileMenu = config.getProfileMenu($$user, { asImmutable: true });
    const { open, isLogginIn } = this.state;
    return (<Grid item xs={12} justify="flex-end" container>

{/*        <If condition={!isLoggedIn}>
          <Button color="primary" variant="contained" className={classes.buttonMyAccount} onClick={(e) => {e.preventDefault(); this.props.history.push('/login')}}><PersonIcon />{i18n.get('loginAction')}</Button>
        </If>*/}
        <If
          condition={
            (userRole === 'member' ||
            userRole === 'admin' ||
            userRole === 'speaker' ||
            userRole === 'staff')
          }
          >
          <Button
            onClick={this.handleToggle}
            endIcon={<IconArrow />}
            buttonRef={(node) => {
              this.anchorEl = node;
            }}
            aria-owns={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            style={{ visibility: open === true ? 'hidden' : 'visible' }}
            className={classes.buttonMyAccount}
            >
            {$$user.get('email')}
          </Button>
          <Popper
            open={open}
            anchorEl={this.anchorEl}
            transition
            disablePortal
            style={{ zIndex: 999 }}
            placement={'bottom-start'}
            >
            {({ TransitionProps, placement }) => (
              <Grow {...TransitionProps} id="menu-list-grow">
                <Paper classes={{ root: classes.profileWrapper }}>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <Box className={classes.padding}>
                      <BlockButton
                        className={classes.profileMenu}
                        lowerCase={true}
                        label={
                          <span>
                            MON COMPTE
                            <IconArrow
                              style={{
                                verticalAlign: 'middle',
                                marginTop: '-2px',
                              }}
                              />
                          </span>
                        }
                        size="small"
                        variant="regular"
                        onClick={this.handleToggle}
                        aria-owns={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        style={{ borderRadius: '0' }}
                        />
                      <MenuList>
                        {$$profileMenu
                          .map((p, pIdx) => {
                            if (p.get('target') === '_blank') {
                              return (
                                <MenuItem
                                  key={'pm_' + pIdx}
                                  onClick={(e) => {
                                    window.open(p.get('url'));
                                  }}
                                  classes={{
                                    root: classes.profileButton,
                                  }}
                                  >
                                  {i18n.get(p.get('title'), {pretty: false})}
                                </MenuItem>
                              );
                            } else {
                              return (
                                <MenuItem
                                  key={'pm_' + pIdx}
                                  onClick={(e) => {
                                    this.handleClose(e, p.get('url'));
                                  }}
                                  classes={{
                                    root: classes.profileButton,
                                  }}
                                  >
                                  {i18n.get(p.get('title'), {pretty: false})}
                                </MenuItem>
                              );
                            }
                          })
                          .toArray()}
                        </MenuList>
                      </Box>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </If>
      </Grid>);
    }
  }

  function mapStateToProps(state) {
    const props = {
      isLoggedIn: isLoggedIn(state),
      $$user: getCurrentUser(state),
    };
    return props;
  }
  function mapDispatchToProps(dispatch) {
    return {
      onLoggedIn: () => {
        dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
      },
    };
  }

  export default withStyles(styles)(
    withRouter(withWidth()(connect(mapStateToProps, mapDispatchToProps)(Header))),
  );



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx